export default {
  created () {
    let that = this
    this.$bus.on('service:change', function (val) {
      switch (val) {
        case 'Payments':
          that.serviceColor = that.servicesColors.PAYMENT
          break

        case 'Sepamail Diamond':
          that.serviceColor = that.servicesColors.DIAMOND
          break

        case 'Sepamail Rubis':
          that.serviceColor = that.servicesColors.RUBIS
          break

        case 'cloudDoc':
          that.serviceColor = that.servicesColors.CLOUD_DOC
          break

        case 'Exchange Document':
          that.serviceColor = that.servicesColors.EXCHANGE_DOC
          break

        case 'Direct Debit':
          that.serviceColor = that.servicesColors.DIRECT_DEBIT
          break

        case 'Direct Payments':
          that.serviceColor = that.servicesColors.DIRECT_DEBIT
          break

        default:
          that.serviceColor = that.servicesColors.DEFAULT
          break
      }
    })
  },
  data () {
    return {
      serviceColor: '#12bcf1',
      servicesColors: {
        PAYMENT: '#12bcf1',
        DIAMOND: '#34BCFF',
        RUBIS: '#FF1A21',
        CLOUD_DOC: '#FF5E0B',
        EXCHANGE_DOC: '#289E19',
        DIRECT_DEBIT: '#12bcf1',
        // DEFAULT: '#d6d6d6'
        DEFAULT: '#ffffff'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dynamicStyleMixin.js